import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../../Layouts/Sidebar-old";
import Papa from "papaparse";
import DataParser from "../../../utlits/Dataparser";
import AttendanceService from "../../../Services/AttendanceService";
import UserProfile from "../../Reuseable/UserProfile.";
import CompanyService from "../../../Services/CompanyService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import moment from "moment";
import { toast } from "react-toastify";
import SocketService from "../../../Services/SocketService";
import { DatePicker, Select } from "antd";
const { Option } = Select;

const AttendanceHr = () => {
  const navigate = useNavigate();
  const compId = DataParser.CompanyId();
  const userid = DataParser.UserId();
  const daysInMonth = DataParser.getDaysInMonth();
  const currentDate = DataParser.getDateinFormat();

  const [parsedData, setParsedData] = useState([]);


  const [isLoading, setLoading] = useState(false);
  const [isUploading, setUploading] = useState(false);

  const [values, setValues] = useState([]);
  const [depList, setDepList] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [attendence, setAttendence] = useState([]);
  const [employeeid, setEmployeeid] = useState("");
  const [deptId, setDeptId] = useState("");
  const [selectMonth, setSelectMonth] = useState("");
  const [selectYear, setSelectYear] = useState("");
  const [allEmployees, setAllEmployees] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState({
    month: moment().format("MM"),
    year: moment().format("YYYY"),
    deptId: "",
    employeeid: ""
  });

  // 🔹 Ant Design Select Styles are handled via CSS now
  const customStyles = {}; // Kept for reference or removed if unused


  useEffect(() => {


    getAttendence();

    // 🟢 Socket Integration
    SocketService.connect();

    const handleAttendanceUpdate = (data) => {
      if (String(data.company_id) === String(compId)) {
        console.log("🔔 Real-time attendance update received:", data);
        getAttendence();
      }
    };

    const handleLeaveUpdate = (data) => {
      if (String(data.company_id) === String(compId)) {
        console.log("🔔 Real-time leave update received:", data);
        getAttendence();
      }
    };

    SocketService.on("attendance_update", handleAttendanceUpdate);
    SocketService.on("leave_update", handleLeaveUpdate);

    return () => {
      SocketService.off("attendance_update", handleAttendanceUpdate);
      SocketService.off("leave_update", handleLeaveUpdate);
    };
  }, []);


  const getAttendence = () => {
    setLoading(true);
    AttendanceService.getAttendanceHrNew(compId)
      .then((res) => {
        const data = res.data?.attandence || [];
        setHolidayList(res.data?.holidays || []);

        setAllEmployees(data);
        setAttendence(data);

        // department unique
        const newArr = data.map((d) => d.department?.[0]).filter(Boolean);
        const unique = newArr.filter(
          (v, i, a) => a.findIndex((v2) => v2.id === v.id) === i
        );
        setDepList(unique);
        setSearchCriteria({
          month: moment().format("MM"),
          year: moment().format("YYYY"),
          deptId: "",
          employeeid: ""
        });
      })
      .catch((err) => {
        console.error("Error fetching attendance:", err);
        toast.error("Failed to fetch attendance data.");
      })
      .finally(() => {
        setLoading(false);
      });
  };



  const changeHandler = (event) => {
    setUploading(true); //

    Papa.parse(event.target.files[0], {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        const valuesArray = results.data
          .map((d) => ({
            empid: d["User ID"] ? parseInt(d["User ID"]) : null,
            date: d["Date"] || "",
            timeIn: d["Punch In"] || "",
            timeOut: d["Punch Out"] || "",
          }))
          // Skip rows with missing fields
          .filter(
            (item) =>
              item.empid &&
              item.date &&
              item.timeIn &&
              item.timeOut
          );

        setParsedData(results.data);
        setValues(valuesArray);

        const companyid = DataParser.CompanyId();
        const Data = { company_id: companyid, data: valuesArray };

        AttendanceService.uploadAttendance(Data)
          .then(() => {
            toast.success("Attendance uploaded successfully!");
            getAttendence();
          })
          .finally(() => {
            setUploading(false);
          });
      },
    });
  };

  const handelSearch = (e) => {
    e.preventDefault();
    setLoading(true);
    const monthToSend = selectMonth || moment().format("MM");
    const yearToSend = selectYear || moment().format("YYYY");

    AttendanceService.getAttendancebySearchHrNew(
      compId,
      employeeid,
      deptId,
      monthToSend,
      yearToSend
    )
      .then((res) => {
        const Data = res.data?.attandence || [];
        setHolidayList(res.data?.holidays || []);

        const daysInSelectedMonth = moment(`${yearToSend}-${monthToSend}`, "YYYY-MM").daysInMonth();
        console.log(`Calculating days for ${yearToSend}-${monthToSend}: ${daysInSelectedMonth}`);


        setAttendence(Data);
        setSearchCriteria({
          month: monthToSend,
          year: yearToSend,
          deptId: deptId,
          employeeid: employeeid
        });
      })
      .catch((err) => {
        console.error("Search failed:", err);
        toast.error("Failed to search attendance records.");
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const handelCheckAttendance = (e, s) => {
    e.preventDefault();
    console.log("s =>", s);
    const name = s.first_name + " " + s.last_name;
    navigate(`/${DataParser.CompanyIdentifierRole()}/employee-attendance`, {
      state: { data: s.id, name: name, month: searchCriteria.month, year: searchCriteria.year },
    });
  };


  const onChange = (date, dateString) => {
    console.log(dateString);
    let year = dateString.split("-")[0];
    let month = dateString.split("-")[1];
    setSelectMonth(month);
    setSelectYear(year);
  };

  const getAttendanceStatus = (formattedDate, attRecord, holidayList, leaves, offDays, specialOffDates) => {
    const d = moment(formattedDate, "YYYY-MM-DD").startOf("day");
    const formatted = formattedDate;
    const dayName = d.format("dddd").toLowerCase();

    // 🔴 Holiday
    if (
      holidayList?.some((h) => {
        const start = moment(h.date, "DD/MM/YYYY").startOf("day");
        const end = h.enddate
          ? moment(h.enddate, "DD/MM/YYYY").endOf("day")
          : start;
        return d.isBetween(start, end, "day", "[]");
      })
    ) {
      return <td className="tableset fw-bold att-h" style={{ width: "35px", minWidth: "35px", padding: "8px 2px", textAlign: "center", fontSize: "11px", borderBottom: "1px solid #EDEDED !important" }}>H</td>;
    }

    // 🟡 Weekly Off (Static)
    if (offDays?.map((d) => d.toLowerCase()).includes(dayName)) {
      return <td className="tableset fw-bold att-o" style={{ width: "35px", minWidth: "35px", padding: "8px 2px", textAlign: "center", fontSize: "11px", borderBottom: "1px solid #EDEDED !important" }}>O</td>;
    }

    // 🟡 Special Off (Alternate)
    if (specialOffDates?.includes(formatted)) {
      return <td className="tableset fw-bold att-o" style={{ width: "35px", minWidth: "35px", padding: "8px 2px", textAlign: "center", fontSize: "11px", borderBottom: "1px solid #EDEDED !important" }}>O</td>;
    }

    // 🔵 Leave
    if (leaves?.some((leave) => moment.utc(leave.date).format("YYYY-MM-DD") === formatted)) {
      return <td className="tableset fw-bold att-l" style={{ width: "35px", minWidth: "35px", padding: "8px 2px", textAlign: "center", fontSize: "11px", borderBottom: "1px solid #EDEDED !important" }}>L</td>;
    }

    // 🟢 Present
    if (attRecord?.timein && attRecord.timein !== "Leave" && attRecord.timein !== "off") {
      return <td className="tableset fw-bold att-p" style={{ width: "35px", minWidth: "35px", padding: "8px 2px", textAlign: "center", fontSize: "11px", borderBottom: "1px solid #EDEDED !important" }}>P</td>;
    }

    // ⚪ No data
    return <td className="tableset fw-bold att-none" style={{ width: "35px", minWidth: "35px", padding: "8px 2px", textAlign: "center", fontSize: "11px", borderBottom: "1px solid #EDEDED !important" }}>-</td>;
  }




  // 🔹 Options for the Employee Dropdown (Derived from staged deptId)
  const dropdownFilteredEmployees = deptId
    ? allEmployees.filter(
      (emp) =>
        emp.department &&
        emp.department.length > 0 &&
        emp.department[0].id === parseInt(deptId)
    )
    : allEmployees;

  const employeeOptions = dropdownFilteredEmployees.map((emp) => ({
    value: emp.id,
    label: `${emp.first_name} ${emp.last_name}`,
  }));


  const displayMonth = searchCriteria.month;
  const displayYear = searchCriteria.year;


  const selectedEmployeeOption = employeeOptions.find(
    (opt) => String(opt.value) === String(employeeid)
  );

  const departmentOptions = depList.map((dep) => ({
    value: dep.id,
    label: dep.name,
  }));

  const selectedDepartmentOption = departmentOptions.find(
    (opt) => String(opt.value) === String(deptId)
  );

  // Helper to calculate days for the currently displayed month
  const daysInCurrentDisplayMonth = moment(`${displayYear}-${displayMonth}`, "YYYY-MM").daysInMonth();

  return (
    <>
      <Helmet>
        <title>Attendance - Planit</title>
      </Helmet>
      {/* <Sidebar /> */}
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            {isUploading && (
              <div className="loader-overlay" style={{ zIndex: 9999 }}>
                <div className="spinner-border" role="status" style={{ color: "#1D1D1D", width: "3rem", height: "3rem" }}>
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p style={{ color: "#1D1D1D", marginTop: "15px", fontWeight: 600 }}>
                  Uploading Attendance...
                </p>
              </div>
            )}
            <div className="row px-0">
              <div className="col-12 px-0">
                <div className="d-flex align-items-center justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex align-items-center gap-2">
                    <label htmlFor="file-input-notes" className="mb-0">
                      <span
                        style={{
                          backgroundColor: "#0DDFAB",
                          borderColor: "#0DDFAB",
                          color: "white",
                          borderRadius: "5px",
                          fontSize: "13px",
                          fontWeight: 600,
                          padding: "6px 12px"
                        }}
                        type="button"
                        className="btn waves-effect waves-light"
                      >
                        <i className="uil-cloud-upload me-1"></i> Upload Attendance
                      </span>
                    </label>
                    <input
                      type="file"
                      name="file"
                      id="file-input-notes"
                      accept=".csv"
                      onChange={changeHandler}
                      style={{ display: "none" }}
                    />
                    <a
                      href="/assets/sampleData.csv"
                      download="Attendance Upload Sample"
                      target="_blank"
                      className="btn waves-effect waves-light"
                      style={{
                        backgroundColor: "#F7F8FA",
                        borderColor: "#F7F8FA",
                        color: "#1D1D1D",
                        borderRadius: "5px",
                        fontSize: "13px",
                        fontWeight: 600,
                        padding: "6px 12px"
                      }}
                    >
                      <i className="uil-cloud-download me-1"></i> Download Sample
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <style>{`
                /* Global Filter Row Styles with float-select-wrap support */
                .custom-filter.float-select-wrap .ant-select-selector,
                .custom-filter.float-select-wrap .ant-picker {
                    height: 34px !important;
                    min-height: 34px !important;
                    border: 1.5px solid #D2D2D2 !important;
                    border-radius: 6px !important;
                }
                
                .custom-filter.float-select-wrap .ant-select-selection-item,
                .custom-filter.float-select-wrap .ant-select-selection-placeholder,
                .custom-filter.float-select-wrap .ant-picker-input > input {
                    line-height: 30px !important;
                    font-size: 13px !important;
                }

                .custom-filter.float-select-wrap label {
                    font-size: 11px !important;
                    font-weight: 600 !important;
                }

                /* Hover/focus on filter fields */
                .custom-filter.float-select-wrap:hover .ant-select-selector,
                .custom-filter.float-select-wrap:focus-within .ant-select-selector {
                    border-color: #1D1D1D !important; box-shadow: none !important;
                }
                .custom-filter.float-select-wrap:hover .ant-picker,
                .custom-filter.float-select-wrap .ant-picker-focused {
                    border-color: #1D1D1D !important; box-shadow: none !important;
                }
                .custom-filter.float-select-wrap:hover label,
                .custom-filter.float-select-wrap:focus-within label { color: #1D1D1D !important; }
                .custom-filter.float-select-wrap:hover .ant-select-arrow,
                .custom-filter.float-select-wrap:focus-within .ant-select-arrow { color: #1D1D1D !important; }
                .custom-filter.float-select-wrap:hover .ant-picker-suffix div,
                .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div { background-color: #1D1D1D !important; }
                .custom-filter.float-select-wrap:hover .ant-picker-suffix div i,
                .custom-filter.float-select-wrap:focus-within .ant-picker-suffix div i { color: #fff !important; }

                .eval-action-btn {
                    height: 34px !important;
                    border-radius: 6px !important;
                    font-size: 13px !important;
                    font-weight: 600 !important;
                    padding: 0 15px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    box-shadow: none !important;
                    color: white !important;
                    background-color: #0DDFAB !important;
                    border: 1px solid #0DDFAB !important;
                }
                .eval-action-btn:hover {
                    background-color: #0bc698 !important;
                    border-color: #0bc698 !important;
                    color: white !important;
                }

                /* Attendance Status Colors */
                .att-h { color: #dc3545 !important; }
                .att-o { color: #ffc107 !important; }
                .att-l { color: #50a5f1 !important; }
                .att-p { color: #42c797 !important; }
                .att-none { color: #adb5bd !important; }
            `}</style>

            <div className="row px-0 mb-2 align-items-center">
              <div className="col-12 d-flex align-items-center justify-content-between px-0">
                {/* Legend on the Left */}
                <div className="attendance-legend d-flex align-items-center gap-3" style={{ paddingTop: "15px" }}>
                  <span className="d-flex align-items-center gap-1" style={{ fontSize: "12px", fontWeight: 600 }}><strong style={{ color: "#dc3545" }}>H</strong> - Holiday</span>
                  <span className="d-flex align-items-center gap-1" style={{ fontSize: "12px", fontWeight: 600 }}><strong style={{ color: "#ffc107" }}>O</strong> - Off</span>
                  <span className="d-flex align-items-center gap-1" style={{ fontSize: "12px", fontWeight: 600 }}><strong style={{ color: "#50a5f1" }}>L</strong> - Leave</span>
                  <span className="d-flex align-items-center gap-1" style={{ fontSize: "12px", fontWeight: 600 }}><strong style={{ color: "#42c797" }}>P</strong> - Present</span>
                </div>

                {/* Filters on the Right */}
                <div className="d-flex align-items-end gap-3">
                  <div className={`float-select-wrap custom-filter ${deptId !== "" ? "has-value" : ""}`} style={{ width: "180px" }}>
                    <label>Department</label>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: '100%' }}
                      placeholder=""
                      value={deptId === "" ? null : deptId}
                      onChange={(val) => setDeptId(val || "")}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {departmentOptions.map(dep => (
                        <Option key={dep.value} value={String(dep.value)} label={dep.label}>{dep.label}</Option>
                      ))}
                    </Select>
                  </div>
                  <div className={`float-select-wrap custom-filter ${employeeid !== "" ? "has-value" : ""}`} style={{ width: "180px" }}>
                    <label>Employee</label>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: '100%' }}
                      placeholder=""
                      value={employeeid === "" ? null : employeeid}
                      onChange={(val) => setEmployeeid(val || "")}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {employeeOptions.map(emp => (
                        <Option key={emp.value} value={emp.value} label={emp.label}>{emp.label}</Option>
                      ))}
                    </Select>
                  </div>
                  <div className={`float-select-wrap custom-filter ${selectMonth !== "" ? "has-value" : ""}`} style={{ width: "160px" }}>
                    <label>Month</label>
                    <DatePicker
                      style={{ width: "100%" }}
                      onChange={onChange}
                      picker="month"
                      placeholder=""
                      suffixIcon={
                        <div style={{
                          backgroundColor: "#F4F4F4",
                          borderRadius: "6px",
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "-4px"
                        }}>
                          <i className="uil-schedule" style={{ color: "#A0A0A0", fontSize: "15px" }} />
                        </div>
                      }
                    />
                  </div>
                  <button
                    onClick={(e) => handelSearch(e)}
                    className="btn eval-action-btn"
                  >
                    <i className="uil-search"></i> Search
                  </button>
                </div>
              </div>
            </div>

            <div className="row px-0">
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "transparent", boxShadow: "none", borderRadius: "0px !important" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive px-0 listing-table-wrapper" style={{ width: "100%", overflowX: "auto", borderRadius: "0px !important" }}>
                      <table className="table mb-0 listing-table custom-table" style={{ minWidth: "1285px", tableLayout: "fixed", border: "none !important", borderRadius: "0px !important" }}>
                        <colgroup>
                          <col style={{ width: "200px" }} />
                          {Array.from({ length: 31 }).map((_, i) => (
                            <col key={i} style={{ width: "35px" }} />
                          ))}
                        </colgroup>
                        <thead>
                          <tr className="tableHeaderbg" style={{ borderBottom: "1.5px solid #EDEDED !important" }}>
                            <th style={{ textAlign: "left", paddingLeft: "15px", backgroundColor: "#F7F8FA !important", color: "#1D1D1D !important", fontWeight: 600, borderRadius: "0px !important" }}>Employees' Name</th>
                            {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                              <th key={day} style={{ textAlign: "center", fontSize: "11px", backgroundColor: "#F7F8FA !important", color: "#1D1D1D !important", fontWeight: 600, borderRadius: "0px !important" }}>
                                {day <= daysInCurrentDisplayMonth ? day : ""}
                              </th>
                            ))}
                          </tr>
                        </thead>

                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={32} rows={6} />
                          ) : attendence && attendence.length > 0 ? (
                            attendence.map((els) => (
                              <tr key={els.id} style={{ borderBottom: "1px solid #EDEDED" }}>
                                {/* Employee */}
                                <td
                                  className="tableset"
                                  onClick={(e) => handelCheckAttendance(e, els)}
                                  style={{ cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", padding: "10px 15px", fontSize: "13px", color: "#1D1D1D", fontWeight: 500 }}
                                >
                                  <div className="d-flex align-items-center gap-2" style={{ overflow: "hidden" }}>
                                    <UserProfile
                                      username={`${els?.first_name} ${els?.last_name}`}
                                      userImage={els?.image}
                                    />
                                    <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                      {(`${els?.first_name} ${els?.last_name}`).split(" ").slice(0, 2).join(" ")}
                                    </span>
                                  </div>
                                </td>

                                {/* Attendance Columns */}


                                {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => {
                                  // Determine if day is valid for this month
                                  const displayMonthUsed = searchCriteria.month;
                                  const displayYearUsed = searchCriteria.year;
                                  const daysInThisMonth = moment(`${displayYearUsed}-${displayMonthUsed}`, "YYYY-MM").daysInMonth();

                                  if (day > daysInThisMonth) {
                                    // Invalid Date (e.g. Feb 30) - Render as empty space
                                    return <td key={day} style={{ padding: "8px 2px", textAlign: "center", fontSize: "11px", background: "#fcfcfc", borderBottom: "1px solid #EDEDED !important" }}></td>;
                                  }

                                  const dateObj = moment(`${displayYearUsed}-${displayMonthUsed}-${day}`, "YYYY-MM-DD");
                                  const formattedDate = dateObj.format("YYYY-MM-DD");
                                  const dayName = dateObj.format("dddd").toLowerCase();



                                  const attRecord = els?.attandence?.find(
                                    (a) => moment(a.date).format("YYYY-MM-DD") === formattedDate
                                  );

                                  return getAttendanceStatus(
                                    formattedDate,
                                    attRecord,
                                    holidayList,
                                    els.leaves,
                                    els.offDays,
                                    els.specialOffDates
                                  );
                                })}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={32} className="text-center align-middle py-4">
                                No attendance records found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceHr;
